import request from "utils/request";
import EventBus from "vertx3-eventbus-client";
var eb = new EventBus("/eventbus");
eb.enableReconnect(true);
var currentHandlers = null;

export async function delay(timeout) {
	return new Promise(resolve => {
		setTimeout(resolve, timeout);
	});
}

export async function getProject(params) {
	return request("/rest/project/" + params.projectId);
}

export async function generateRandomInfo() {
	return request("/random_info");
}

export async function saveAccountCreationProject(params) {
	return request("/rest/acproject", {
		method: "POST",
		body: params
	});
}

export async function savePostingProject(params) {
	return request("/rest/postingproject", {
		method: "POST",
		body: params
	});
}

export async function savePrivateProject(params) {
	return request("/rest/privateproject", {
		method: "POST",
		body: params
	});
}

export async function saveIndexerProject(params) {
	return request("/rest/indexerproject", {
		method: "POST",
		body: params
	});
}

export async function downloadRankerXEmail() {
	return request("/action/email/download", {
		method: "POST",
		body: "fastmailsEmail"
	});
}

export async function downloadEmailFromEmailList() {
	return request("/action/email_list/download");
}

export async function testEmail(params) {
	return request("/action/email/test_login", {
		method: "POST",
		body: params
	});
}

export async function saveSchedule(params) {
	let data = {
		status: "SCHEDULED",
		schedule: params.schedule
	};
	// console.log(params);
	return request("/rest/schedule/" + params.projectId, {
		method: "POST",
		body: data
	});
}

export async function deleteSchedule(projectId) {
	return request("/action/delete/schedule/" + projectId);
}

export async function resetSchedule(projectId) {
	return request("/action/reset/schedule/" + projectId);
}

export async function login(params) {
	return request("/public/api/login/account", {
		method: "POST",
		body: params
	});
}

export async function startProject(projectId) {
	return request("/action/start/project/" + projectId);
}

export async function stopProject(projectId) {
	return request("/action/stop/project/" + projectId);
}

export async function startVerifyingMails(projectId) {
	return request("/action/start/verifying/" + projectId);
}

export async function stopVerifyingMails(projectId) {
	return request("/action/stop/verifying/" + projectId);
}

export async function logout(params) {
	return request("/api/logout");
}

export async function getOptions(params) {
	return request("/rest/options");
}

export async function checkBalance(params) {
	return request("/action/check_balance/captcha/", {
		method: "POST",
		body: params
	});
}

export async function checkIndexerBalance(payload) {
	return request("/action/check_balance/indexer", {
		method: "POST",
		body: payload
	});
}

export async function getPrivateNetworkSiteStatusForProject(payload) {
	return request("/rest/privatesitestatus", {
		method: "POST",
		body: payload
	});
}

export async function getContentGroups() {
	return request("/rest/content_groups");
}

export async function getAllProfilesWithCampaigns() {
	return request("/rest/campaigns_with_profiles");
}

export async function getSites() {
	return request("/sites.json");
}

export async function getSiteSelections() {
	return request("/rest/site_selections");
}

export async function getSiteInfos() {
	return request("/rest/sites");
}

export async function checkPrimaryCaptcha() {
	return request("/action/check_balance/primary_captcha");
}

export async function checkPrimaryGoogleCaptcha() {
	return request("/action/check_balance/primary_google_captcha");
}

export function registerHandler(handlers) {
	// try {
	// 	// if (currentHandlers != null) {
	// 	// 	for (let handler of currentHandlers) {
	// 	// 		eb.unregisterHandler(handler.path, handler.handler);
	// 	// 	}
	// 	// }
	// 	if (eb != null) {
	// 		console.log("Closing eventbus");
	// 		eb.close();
	// 	}
	// } catch (err) {
	// 	console.log(err);
	// }
	// eb = new EventBus("/eventbus");
	// eb.enableReconnect(true);
	// eb.onopen = () => {
	// 	for (let handler of handlers) {
	// 		eb.registerHandler(handler.path, handler.handler);
	// 	}
	// 	// currentHandlers = handlers;
	// };
	// eb.onclose = () => {};
	// return;
	if (eb.state == EventBus.OPEN) {
		if (currentHandlers != null) {
			for (let handler of currentHandlers) {
				eb.unregisterHandler(handler.path, handler.handler);
			}
		}
		for (let handler of handlers) {
			eb.registerHandler(handler.path, handler.handler);
		}
		currentHandlers = handlers;
		// return;
	}
	// if (true) {
	eb.onopen = () => {
		if (currentHandlers != null) {
			for (let handler of currentHandlers) {
				eb.unregisterHandler(handler.path, handler.handler);
			}
		}
		for (let handler of handlers) {
			eb.registerHandler(handler.path, handler.handler);
		}
		currentHandlers = handlers;
	};
	return;
	// }

	// console.log("Unexpected error");
}
